module.exports = __webpack_public_path__ + "static/media/29ADMSPC22.882ad553.jpg";